import { connect } from "react-redux";
import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import {
  customToast,
  getShopifyConnectionLabel,
  isShopifyConnected,
  isShopifyConnectionButtonDisabled,
} from "../../../shared/utility";

import Topbar from "../../../shared/components/topbar/Topbar";
import Button from "../../../shared/components/Buttons/Button";
import { ReactComponent as ShopifyLogo } from "../../../assets/images/shopifyLogo.svg";
import {
  buttonNameConstants,
  EMPTY_STRING,
  storeConstants,
  toastMessages,
  toastType,
} from "../../../constants";
import SimpleInputTextField from "../../../shared/components/inputTextField/SimpleInputTextField";
import { storeService } from "../../../services";
import { storeActions, systemActions } from "../../../redux/actions";
import ShopifyCustomerSyncing from "../../../shared/components/shopifyCustomerSyncing/ShopifyCustomerSyncing";

const ShopifyConnection = (props) => {
  const { currentStore, activateSpinner, deactivateSpinner } = props;
  const isConnected = isShopifyConnected(currentStore);
  const [isLoading, setIsLoading] = useState(false);
  const [shop, setShop] = React.useState(EMPTY_STRING);
  const handleConnectShopify = async () => {
    try {
      if (isConnected) {
        setIsLoading(true);
        let res = await storeService.connectShopify({
          shop: currentStore.shopify.shop,
          storeId: currentStore.id,
        });
        if (res) {
          window.location.replace(res);
        } else {
          customToast(toastMessages.SOMETHING_WENT_WRONG, toastType.ERROR);
        }
      } else {
        window.location.replace(process.env.REACT_APP_SHOPIFY_APP_INSTALL_URL);
      }
    } catch (e) {
      customToast(toastMessages.SOMETHING_WENT_WRONG, toastType.ERROR);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (currentStore?.id) {
      props.getUpdatedCurrentStoreDetails(currentStore?.id);
      setShop(currentStore?.shopify?.shop || EMPTY_STRING);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (currentStore?.id) {
      setShop(currentStore?.shopify?.shop || EMPTY_STRING);
    }
  }, [currentStore]);

  return (
    <>
      <Topbar title="Shopify Connection"></Topbar>
      <Row className=" d-flex justify-content-center align-items-center">
        <Col md={11}>
          <Col
            md={5}
            className="mx-auto d-flex flex-column gap-3 billing-card-wrapper"
          >
            <ShopifyLogo className="mx-auto" width={128} />
            <Button
              type="button"
              className={"w-100 mt-0"}
              handleClick={handleConnectShopify}
              isDisabled={isShopifyConnectionButtonDisabled(
                currentStore,
                isLoading
              )}
              label={getShopifyConnectionLabel(currentStore)}
            />
            <p className="w-100 ">
              {isConnected && (
                <>
                  This store is already connected with
                  <b> {currentStore?.shopify?.shop} </b>
                </>
              )}
              All Customers will be synced automatically, and Inventory Items
              will need to be synced selectively.
            </p>

            {isConnected && <ShopifyCustomerSyncing />}
          </Col>
        </Col>
      </Row>
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  currentStore: state.store.currentStore,
  spinnerArray: state.system.spinnerArray,
  company: state.authentication.company,
  user: state.authentication.user,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  activateSpinner: (data) => dispatch(systemActions.activateSpinner(data)),
  deactivateSpinner: (data) => dispatch(systemActions.deactivateSpinner(data)),
  getUpdatedCurrentStoreDetails: (storeId) =>
    dispatch(storeActions.getUpdatedCurrentStoreDetails(storeId)),
});

//-------Export AddNewUser Component
export default connect(mapStateToProps, mapDispatchToProps)(ShopifyConnection);
